/** Typography Style registry — the voice of the text. */

export const TYPOGRAPHY_STYLES = [
  { id: 'modern-sans', name: 'Modern Sans' },
  { id: 'elegant-serif', name: 'Elegant Serif' },
  { id: 'bold-display', name: 'Bold Display' },
  { id: 'luxury-serif', name: 'Luxury Serif' },
  { id: 'minimal-sans', name: 'Minimal Sans' },
  { id: 'rounded', name: 'Rounded' },
  { id: 'editorial', name: 'Editorial' },
  { id: 'classic', name: 'Classic' },
  { id: 'playful', name: 'Playful' },
  { id: 'handwritten', name: 'Handwritten' },
];
